import { Access } from '../../enums';
import { Permission } from '../permission';

const ADMIN_AND_INVOICE_KEY = 'invoice-and-administration';
export const ADMINISTRATION_AND_INVOICING = {
  BACKUP: new Permission({
    key: `${ADMIN_AND_INVOICE_KEY}:backup:${Access.WRITE}`,
    description: 'Datensicherung durchführen',
  }),

  PAYER: {
    READ: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:payer:${Access.READ}`,
      description: 'Kostenträger – Leserecht',
    }),

    WRITE: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:payer:${Access.WRITE}`,
      description: 'Kostenträger - Schreibrecht',
    }),
  },

  INVOICE: {
    READ: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:invoice:${Access.READ}`,
      description: 'Rechnung – Leserecht',
    }),

    WRITE: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:invoice:${Access.WRITE}`,
      description: 'Rechnung - Schreibrecht',
    }),

    DELETE: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:invoice:${Access.DELETE}`,
      description: 'Rechnung Löschrecht',
    }),
  },

  ADMINISTRATE: {
    READ: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:administrate:${Access.READ}`,
      description: 'Verwaltung Admin – Leserecht',
    }),

    WRITE: new Permission({
      key: `${ADMIN_AND_INVOICE_KEY}:administrate:${Access.WRITE}`,
      description: 'Verwaltung Admin - Schreibrecht',
    }),
  },
};
